import { StandardEvents } from '@wallet-standard/features';
export function walletHasStandardEventsFeature(wallet) {
    return StandardEvents in wallet.features;
}
//# sourceMappingURL=events.js.map